import { Icon } from 'antd';
import { isUrl } from '../utils/utils';
import { getConfig } from 'src/services/server-url-config/env';
const urlConfig = getConfig();

const RobotSvg = () => (
  <svg width="1.05em" height="1.05em" stroke="currentColor" viewBox="0 0 18 16" strokeWidth="0.7" fill="currentColor">
    <path
      d="M15.3142857,9.20294927 L14.5142857,9.20294927 C14.5142857,7.096927 13.6,5.57591091 12.2285714,4.63990102 L13.7142857,1.36386637 C14.0571429,1.36386637 14.2857143,1.1298639 14.2857143,0.778860184 C14.2857143,0.544857709 14.1714286,0.193853997 13.9428571,0.0768527599 C13.7142857,-0.0401484774 13.3714286,-0.0401484774 13.1428571,0.193853997 C12.9142857,0.427856472 12.9142857,0.778860184 13.1428571,1.01286266 L11.5428571,4.2888973 C10.4,3.82089235 9.14285714,3.46988864 7.88571429,3.58688988 C6.62857143,3.58688988 5.37142857,3.82089235 4.22857143,4.40589854 L2.74285714,1.1298639 C2.85714286,0.895861421 2.85714286,0.544857709 2.74285714,0.310855235 C2.51428571,0.0768527599 2.17142857,0.0768527599 1.94285714,0.193853997 C1.6,0.310855235 1.48571429,0.544857709 1.6,0.895861421 C1.6,1.1298639 1.82857143,1.36386637 2.17142857,1.36386637 L3.77142857,4.63990102 C2.4,5.57591091 1.48571429,7.096927 1.48571429,9.20294927 L0.685714286,9.20294927 C0.571428571,9.20294927 0.342857143,9.31995051 0.228571429,9.43695174 C0.114285714,9.55395298 0,9.78795546 0,9.90495669 L0,11.542974 C0,11.6599753 0.114285714,11.8939777 0.228571429,12.010979 C0.342857143,12.1279802 0.457142857,12.2449814 0.685714286,12.2449814 L1.48571429,12.2449814 L1.48571429,13.0639901 C1.48571429,13.6489963 1.94285714,14 2.4,14 L13.6,14 C14.1714286,14 14.5142857,13.5319951 14.5142857,13.0639901 L14.5142857,12.2449814 L15.3142857,12.2449814 C15.6571429,12.2449814 16,11.8939777 16,11.542974 L16,9.90495669 C16,9.67095422 15.8857143,9.55395298 15.7714286,9.43695174 C15.6571429,9.31995051 15.5428571,9.20294927 15.3142857,9.20294927 Z M1.25714286,11.542974 L0.571428571,11.542974 L0.571428571,9.90495669 L1.25714286,9.90495669 L1.25714286,11.542974 Z M13.9428571,12.9469889 C13.9428571,13.1809913 13.8285714,13.2979926 13.6,13.2979926 L2.4,13.2979926 C2.17142857,13.2979926 2.05714286,13.1809913 2.05714286,12.9469889 L2.05714286,9.43695174 C2.05714286,4.87390349 6.17142857,4.40589854 8,4.2888973 C9.82857143,4.17189607 13.9428571,4.75690225 13.9428571,9.31995051 L13.9428571,12.9469889 Z M15.3142857,11.542974 L14.6285714,11.542974 L14.6285714,9.90495669 L15.3142857,9.90495669 L15.3142857,11.542974 Z"
      id="Shape"
    />
    <path
      d="M5.64859684,8 C4.87925165,8 4,8.37554932 4,9.34482759 C4,9.75862069 4.10990646,10.1724138 4.43962582,10.4827586 C4.76934519,10.7931034 5.09906456,11 5.53869038,11 L10.3745744,11 C11.1439196,11 12,10.3657227 12,9.5 C12,8.40631104 10.9241067,8 10.4844809,8 L5.64859684,8 Z M5.77645765,10.3915039 C5.55956088,10.3915039 4.73859083,10.2000779 4.73859083,9.51219356 C4.73859083,8.75841527 5.52565957,8.63288322 5.65670883,8.63288322 L10.2269389,8.63288322 C10.4571658,8.63288322 11.2312323,8.77925268 11.2312323,9.51219356 C11.2312323,10.1513718 10.533264,10.3915039 10.3466877,10.3915039 L5.77645765,10.3915039 Z"
      id="Shape"
    />
  </svg>
);

const RobotIcon = (props) => <Icon component={RobotSvg} {...props} />;

function formatter(data, parentPath = '/', parentAuthority) {
  return data.map((item) => {
    let { path } = item;
    if (!isUrl(path)) {
      path = parentPath + item.path;
    }
    const result = {
      ...item,
      path,
      authority: item.authority || parentAuthority,
    };
    if (item.children) {
      result.children = formatter(item.children, `${parentPath}${item.path}/`, item.authority);
    }
    return result;
  });
}

function isIOS() {
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
  const iosOrAndroid = isiOS || isAndroid;
  return iosOrAndroid;
}

function createMenuData() {
  const array = [
    {
      name: i('机器人'),
      icon: <RobotIcon />,
      path: '/robot',
      permissionCode: 'Robot.view',
	    regions: ['eu', 'sg', 'us'],
      children: [
        {
          name: i('机器人管理'),
          path: '/manager',
          permissionCode: 'Robot.Manager.view',
		    regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('任务管理'),
          path: '/task',
          permissionCode: 'Robot.Task.view',
		      regions: ['eu', 'sg', 'us'],
        },
      ],
    },
    {
      name: i("备份与恢复"),
      icon: <Icon type="sync" />,
      path: "/backup-restore",
      permissionCode: "BackupAndRecovery.view",
      key: "backup-restore",
      children: [
        {
          name: i('机器人备份'),
          path: '/robot-backup',
          key: "robot-backup",
          permissionCode: 'BackupAndRecovery.MachineBackup.view',
        },
        {
          name: i('计划列表'),
          path: '/recovery-plan',
          key: "recovery-plan",
          permissionCode: 'BackupAndRecovery.RecoveryPlanList.view',
        },
      ]
    },
    {
      name: i('事件中心'),
      icon: 'snippets',
      path: '/event',
      permissionCode: 'EventCenter.view',
      regions: ['sg', 'us'],
      children: [
        {
          name: i('事件订阅'),
          path: '/template-content/eventSubscribe/viewSubscribe',
          permissionCode: 'EventCenter.EventSubscribe.view',
		      regions: ['sg', 'us']
        },
        {
          name: i('事件分析'),
          path: '/new-event-analysis',
          key: 'new-event-analysis',
          permissionCode: 'EventCenter.AnalysisExternal.view',
          regions: ['sg', 'us'],
        },
      ],
    },
    {
      name: i('地图管理'),
      icon: 'file-markdown',
      path: '/map',
      permissionCode: 'MapManager.view',
	    regions: ['sg', 'us'],
      children: [
        {
          name: i('地图列表'),
          path: '/list',
          permissionCode: 'MapManager.List.view',
		    regions: ['sg', 'us'],
        },
        {
          name: i('下发记录'),
          path: '/issued-record',
          permissionCode: 'MapManager.TransmissionList.view',
		    regions: ['sg', 'us'],
        },
        {
          name: i('编辑记录'),
          path: '/edit-record',
          permissionCode: 'MapManager.EditRecord.view',
		  regions: ['sg', 'us'],
        },
      ],
    },
    {
      name: i('升级服务'),
      icon: 'rise',
      path: '/upgrade-service',
      permissionCode: 'ExternalUpgradeService.view',
	    regions: ['sg', 'us'],
      children: [
        {
          name: i('机器人升级'),
          path: '/robot-upgrade-service',
          permissionCode: 'ExternalUpgradeService.RobotUpgrade.view',
	        regions: ['sg', 'us'],
        },
        {
          name: i('版本推送计划'),
          path: '/push-manager-service',
          permissionCode: 'ExternalUpgradeService.FirmwarePushPlan.view',
	        regions: ['sg', 'us'],
        },
      ],
    },
    {
      name: i('数据平台'),
      icon: 'dashboard',
      path: '/dataPlatform',
      permissionCode: 'dataPlatform.view',
      regions: ['sg', 'us'],
      children: [
        {
          name: i('核心备件看板'),
          path: '/coreSparePartBoard-Summary',
          permissionCode: 'dataPlatform.coreSparePartBoard-Summary',
          // regions: ['sg', 'us'],
        },
        {
          name: i('核心备件看板'),
          path: '/coreSparePartKanbanA',
          permissionCode: 'dataPlatform.coreSparePartKanbanA',
          // regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('核心备件看板'),
          path: '/coreSparePartKanbanB',
          permissionCode: 'dataPlatform.coreSparePartKanbanB',
          // regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('核心备件看板'),
          path: '/coreSparePartKanbanC',
          permissionCode: 'dataPlatform.coreSparePartKanbanC',
          // regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('核心备件看板'),
          path: '/coreSparePartKanbanX',
          permissionCode: 'dataPlatform.coreSparePartKanbanX',
          // regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('核心备件看板'),
          path: '/coreSparePartKanbanY',
          permissionCode: 'dataPlatform.coreSparePartKanbanY',
          // regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('核心备件看板'),
          path: '/coreSparePartKanbanZ',
          permissionCode: 'dataPlatform.coreSparePartKanbanZ',
          // regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('核心备件看板'),
          path: '/coreSparePartKanban-English',
          permissionCode: 'dataPlatform.coreSparePartKanban-English',
          // regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('故障排查说明'),
          path: '/faultTroubleShooting-Chinese',
          permissionCode: 'dataPlatform.faultTroubleShooting-Chinese',
          // regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('故障排查说明'),
          path: '/faultTroubleShooting-English',
          permissionCode: 'dataPlatform.faultTroubleShooting-English',
          // regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('故障排查说明'),
          path: '/faultTroubleShooting-Japanese',
          permissionCode: 'dataPlatform.faultTroubleShooting-Japanese',
          // regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('机器数据报表'),
          path: '/robotUsageDataDashboard-English',
          permissionCode: 'dataPlatform.robotUsageDataDashboard-English',
          regions: ['eu', 'sg', 'us'],
        },
        {
          name: i('机器数据报表'),
          path: '/robotUsageDataDashboard-Chinese',
          permissionCode: 'dataPlatform.robotUsageDataDashboard-Chinese',
        },
        {
          name: i('机器数据报表'),
          path: '/robotUsageDataDashboard-Japanese',
          permissionCode: 'dataPlatform.robotUsageDataDashboard-Japanese',
        },
      ],
    },
  ];
  console.log('isIOS', isIOS());
  return array;
}

const menuData = createMenuData();

export const getMenuData = () => {
  return formatter(menuData);
};
